import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  ImageBackground,
  TouchableOpacity,
  ActivityIndicator,
  SafeAreaView,
  Modal,
  TextInput
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';

const ReviewDashboard = () => {
  const [collabs, setCollabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [message, setMessage] = useState('');
  const [successVisible, setSuccessVisible] = useState(false);
  const navigation = useNavigation();

  const loadData = () => {
    fetch('https://collabbayadmin.com/APIControllers/GetCreatorsForReview.php', {
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => {
        setCollabs(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  const openModal = (item) => {
    setSelectedItem(item);
    setMessage(
      `${item.Promoter}, we hope you had a 5 star experience at ${item.ListingName || 'our venue'} and captured some great content. We'd love you to leave us a Google review if so!`
    );
    setModalVisible(true);
  };

  const sendReviewPrompt = async (withMessage) => {
    if (!selectedItem) return;
    setModalVisible(false);

    const payload = {
      email: selectedItem.UserEmail,
      listingName: selectedItem.ListingName || 'your venue',
      redeemID: selectedItem.CollabID,
      message: withMessage ? message : '',
    };

    const res = await fetch('https://collabbayadmin.com/APIControllers/SendReviewRequest.php', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(payload).toString(),
    });

    const result = await res.json();
    if (result.status === 'success') {
      setSuccessVisible(true);
      loadData();
    } else {
      alert("Failed to send.");
    }
  };


  if (loading) {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
      <ActivityIndicator size="large" color="black" />
    </View>
  );
}


  const total = collabs.length;
  const pending = collabs.filter(item => !item.ReviewSentStatus || item.ReviewSentStatus !== 'Y').length;



  
  return (
    <SafeAreaView style={styles.safe}>
      <ScrollView contentContainerStyle={styles.scroll}>
        {/* Google Header with black icon */}
      

      <View style={styles.backContainer}>
  <TouchableOpacity onPress={() => navigation.goBack()}>
    <Ionicons name="arrow-back" size={24} color="black" />
  </TouchableOpacity>
</View>


    <View
  style={{
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start', // 👈 left align
    marginBottom: 10,
    width: '100%',
  }}
>
  <Text
    style={{
      fontSize: 22,
      fontWeight: '700',
    paddingLeft: 5,
    }}
  >
     Request Google Reviews{' '}
    <Text
      style={{
        fontSize: 12,
        color: '#FDF05D',
        backgroundColor: '#000',
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 12,
        overflow: 'hidden',
        marginLeft: 6,
      }}
    >
      ✨ NEW
    </Text>
  </Text>
</View>



  
  <View style={styles.infoBanner}>
  <Ionicons name="information-circle-outline" size={20} color="#555" style={{ marginRight: 8, marginTop: 2 }} />
  <View style={{ flex: 1 }}>
    <Text style={styles.infoText}>
      With one click, request a Google review from creators who visited your venue.  
      We'll trigger a notification, and include a link directing them to review your venue on Google.
    </Text>
    <View style={styles.dividerLine} />
    <Text style={styles.infoNote}>
      ⚡ Reviews are optional — this notifcation tool simply makes it easy to request, creators maintain agency.
    </Text>
  </View>
</View>


        {/* Stats */}
        {/* <View style={styles.statsRow}>
          <View style={styles.statCard}>
            <Text style={styles.statValue}>{total}</Text>
            <Text style={styles.statLabel}>Total Visits</Text>
          </View>
          <View style={styles.statCard}>
            <Text style={styles.statValue}>{pending}</Text>
            <Text style={styles.statLabel}>Pending Prompts</Text>
          </View>
        </View> */}

        {/* Collab Cards */}
      

      {/* Collab Cards */}
{collabs.length > 0 ? (
  collabs.map((item, index) => (
    <View key={index} style={styles.card}>
      <ImageBackground
        source={{ uri: item.ProfileImage || 'https://collabbay.com/assets/default-profile.png' }}
        style={styles.profileImageBg}
        imageStyle={{ borderRadius: 14 }}
      />
      <View style={styles.cardContent}>
        <Text style={styles.promoter}>{item.Promoter}</Text>
        <Text style={styles.daysAgo}>Visited {item.DaysAgo} days ago</Text>
      </View>
      {!item.ReviewSentStatus || item.ReviewSentStatus !== 'Y' ? (
        <TouchableOpacity style={styles.sendButton} onPress={() => openModal(item)}>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Ionicons name="send-outline" size={16} color="#000" style={{ marginRight: 4 }} />
            <Text style={styles.sendButtonText}>
              Request a <Text style={{ fontWeight: '700', color: '#4285F4' }}>G</Text>
              <Text style={{ fontWeight: '700', color: '#DB4437' }}>o</Text>
              <Text style={{ fontWeight: '700', color: '#F4B400' }}>o</Text>
              <Text style={{ fontWeight: '700', color: '#4285F4' }}>g</Text>
              <Text style={{ fontWeight: '700', color: '#0F9D58' }}>l</Text>
              <Text style={{ fontWeight: '700', color: '#DB4437' }}>e</Text> review
            </Text>
          </View>
        </TouchableOpacity>
      ) : (
        <View style={styles.sentTagBox}>
          <Ionicons name="checkmark-circle" size={14} color="#2e7d32" style={{ marginRight: 4 }} />
          <Text style={styles.sentTag}>Sent</Text>
        </View>
      )}
    </View>
  ))
) : (
  <View style={styles.emptyCard}>
    <Ionicons name="information-circle-outline" size={20} color="#555" style={{ marginRight: 8 }} />
    <Text style={styles.emptyText}>
      First you need past influencer visits to send Google review requests. Return once you've completed some bookings.
    </Text>
  </View>
)}


      </ScrollView>

      {/* Modal for sending */}
      <Modal visible={modalVisible} transparent animationType="slide">
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <TouchableOpacity
              style={{ position: 'absolute', top: 8, right: 8 }}
              onPress={() => setModalVisible(false)}
            >
              <Ionicons name="close" size={22} color="#000" />
            </TouchableOpacity>
            <Text style={styles.modalTitle}>Request Google Review</Text>
            <Text style={styles.modalSubtitle}>Optional message (max 300 chars)</Text>
            <TextInput
              style={styles.modalInput}
              value={message}
              onChangeText={(text) => setMessage(text.slice(0, 300))}
              placeholder="Add a personal note (optional)"
              multiline
            />
            <TouchableOpacity onPress={() => setMessage('')} style={{ marginBottom: 10 }}>
              <Text style={{ fontSize: 12, color: '#007bff', textAlign: 'right' }}>Clear message</Text>
            </TouchableOpacity>
            <View style={styles.modalActions}>
              <TouchableOpacity style={styles.modalButtonAlt} onPress={() => sendReviewPrompt(false)}>
                <Text style={styles.modalButtonText}>Send Without Message</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.modalButton} onPress={() => sendReviewPrompt(true)}>
                <Text style={styles.modalButtonText}>Send With Message</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Success modal */}
      <Modal visible={successVisible} transparent animationType="fade">
        <View style={styles.modalOverlay}>
          <View style={styles.successModalContent}>
            <Ionicons name="checkmark-circle-outline" size={40} color="green" />
            <Text style={styles.successText}>
              Request sent through Collabbay. The creator has been notified and can optionally leave a review.
            </Text>
            <TouchableOpacity style={styles.modalButton} onPress={() => setSuccessVisible(false)}>
              <Text style={styles.modalButtonText}>OK</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
};

export default ReviewDashboard;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: '#fff', alignItems: 'center' },
  scroll: { width: '100%', maxWidth: 600, padding: 20 },
  googleBanner: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 10 },
  headerTextTop: { fontSize: 22, fontWeight: '700', marginLeft: 10 },
  infoBanner: {
    flexDirection: 'row',
    backgroundColor: '#f3f3f3',
    padding: 10,
    borderRadius: 15,
    marginBottom: 23,
    alignItems: 'flex-start',
  },
  infoText: { fontSize: 13, color: '#555', flex: 1, lineHeight: 18 },
  statsRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 25 },
  statCard: {
    backgroundColor: '#f3f3f3',
    padding: 15,
    borderRadius: 12,
    flex: 1,
    alignItems: 'center',
    marginHorizontal: 5,
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowRadius: 5,
  },
  statValue: { fontSize: 20, fontWeight: '700' },
  statLabel: { fontSize: 12, color: '#666', marginTop: 5 },
  card: {
    backgroundColor: '#fff',
    borderRadius: 14,
    flexWrap: 'wrap',  
    padding: 10,
    marginBottom: 15,
    flexDirection: 'row',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOpacity: 0.07,
    shadowRadius: 6,
  },
  backContainer: {
  width: '100%',
  paddingHorizontal: 7,
  marginBottom: 10,
},

  profileImageBg: {
    width: 60,
    height: 60,
    borderRadius: 14,
    overflow: 'hidden',
    marginRight: 12,
  },
  cardContent: { flex: 1, justifyContent: 'center' },
  promoter: { fontWeight: '600', fontSize: 16, marginBottom: 3 },
  daysAgo: { fontSize: 15, color: '#999', marginBottom: 6 },
  

  sendButton: {
  backgroundColor: '#FDF05D',
  paddingVertical: 8,
  paddingHorizontal: 12,
  borderRadius: 15,
  flexShrink: 0,           // ✅ stops shrinking
  marginTop: 6,            // ✅ if it wraps to next line add space
},
sendButtonText: {
  fontWeight: '600',
  fontSize: 13,
  color: '#000',
  flexWrap: 'wrap',
},

  sentTagBox: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#c8e6c9',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 8,
  },
  sentTag: { color: '#2e7d32', fontWeight: '700', fontSize: 12 },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 20,
    width: '100%',
    maxWidth: 400,
  },
  modalTitle: { fontSize: 18, fontWeight: '600', marginBottom: 8 },
  modalSubtitle: { fontSize: 12, color: '#777', marginBottom: 8 },
  modalInput: {
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 8,
    padding: 8,
    height: 80,
    marginBottom: 5,
    fontSize: 14,
    textAlignVertical: 'top',
  },
  modalActions: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 10 },
  modalButton: {
    backgroundColor: '#FDF05D',
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderRadius: 8,
    flex: 1,
    marginLeft: 5,
    alignItems: 'center',
  },
  modalButtonAlt: {
    backgroundColor: '#eee',
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderRadius: 8,
    flex: 1,
    marginRight: 5,
    alignItems: 'center',
  },
  modalButtonText: { fontWeight: '600', fontSize: 13, color: '#000', textAlign: 'center' },
  successModalContent: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
    width: '100%',
    maxWidth: 300,
  },
  creatorSectionNote: {
  fontSize: 13,
  color: '#555',
  marginBottom: 12,
  textAlign: 'center',
},

  successText: { fontSize: 16, marginVertical: 10, textAlign: 'center' },
  footer: {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  flexDirection: 'row',
  justifyContent: 'space-around',
  paddingVertical: 12,
  borderTopWidth: 1,
  borderColor: '#e5e5e5',
  backgroundColor: '#fff',
  width: '100%',
},
emptyCard: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#f3f3f3',
  padding: 15,
  borderRadius: 12,
  marginBottom: 15,
},
emptyText: {
  fontSize: 14,
  color: '#555',
  flex: 1,
  lineHeight: 18,
},
infoBanner: {
  flexDirection: 'row',
  backgroundColor: '#f3f3f3',
  padding: 12,
  borderRadius: 10,
  marginBottom: 20,
  alignItems: 'flex-start',
},
infoText: {
  fontSize: 13,
  color: '#333',
  lineHeight: 18,
},
dividerLine: {
  height: 1,
  backgroundColor: '#ddd',
  marginVertical: 8,
},
infoNote: {
  fontSize: 12,
  color: '#555',
  lineHeight: 17,
},


});
